import LoadingStateMicro from '@/components/LoadingStateMicro'

export default {
  components: {
    LoadingStateMicro
  },

  methods: {
    rebindValues (origin, copy, fields) {
      fields.map((key) => {
        if (copy.hasOwnProperty(key) && origin.hasOwnProperty(key)) {
          copy[key] = origin[key]
        } else {
          origin[key] = copy[key]
        }
      })
    },

    cleanFields (tax) {
      Object.keys(this.schema).map(schemaField => {
        if (Array.isArray(tax[schemaField]) && tax[schemaField].length === 0) {
          tax[schemaField] = null
        }
        if (typeof (tax[schemaField]) === 'string' && !tax[schemaField]) {
          tax[schemaField] = null
        }
      })
    },

    async closeDialogMixin (toastNotification) {
      this.$toast.success(this.$t(toastNotification))
      this.dialog = false
      this.$emit('refreshTaxes')
    }
  }
}
